import confetti from "canvas-confetti";
import React, { FC, useEffect, useRef } from "react";

const ConfettiAnimation: FC<{ className?: string; playTimeout?: number }> = ({
  className,
  playTimeout = 0
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const to = setTimeout(() => {
      if (!canvasRef.current) {
        return;
      }

      const myConfetti = confetti.create(canvasRef.current, {
        resize: true,
        useWorker: true
      });

      void myConfetti({
        particleCount: 120,
        spread: 70,
        origin: { y: 0.3 },
        disableForReducedMotion: true
      });
    }, playTimeout);

    return () => clearTimeout(to);
  }, [playTimeout]);

  return (
    <canvas
      ref={canvasRef}
      className={className}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 100
      }}
    />
  );
};

export default ConfettiAnimation;
